import React from "react"
import styled from "styled-components"
import { css } from "../styles/GlobalStyles"

import ProfilePic from "./ProfilePic"
import ProfileInfo from "./ProfileInfo"

const ProfileContainer = styled.div`
  height: 95px;
  width: var(--full-width);
  overflow: hidden;

  display: grid;
  grid-template-columns: 3fr 7fr;
  grid-template-rows: 1fr;

  @media (min-width: ${css.breakpoints.split}) {
    height: 400px;
    grid-template-columns: 1fr;
    grid-template-rows: 7fr 3fr;
  }
`

type Props = {
  name: string
  job: string
  pronunciation: string
  photo: string
  email: string
}

const Profile = ({name, job, pronunciation, photo, email}: Props) => {
  return (
    <ProfileContainer>
      <ProfilePic url={photo} />
      <ProfileInfo
        name={name}
        job={job}
        pronunciation={pronunciation}
        email={email}
      />
    </ProfileContainer>
  )
}

export default Profile